<ul class="navbar-nav topbar-actions topbar-actions-left me-auto ms-3" *ngIf="isSuperAdmin">
    <li class="nav-item topbar-action" ngbDropdown>
        <a ngbDropdownToggle class="nav-link topbar-pill dropdown-toggle" href="javascript:void(0)"
            id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <!-- <span class="topbar-pill-icon">
                <i class="fas fa-user-shield"></i>
            </span> -->
            <span class="d-none d-md-inline">Administración</span>
            <i-feather name="chevron-down" class="topbar-chevron"></i-feather>
        </a>

        <div class="dropdown-menu mailbox dropdown-menu-end dropdown-menu-animate-up admin-menu-dropdown" ngbDropdownMenu>
            <span class="with-arrow">
                <span class="bg-primary"></span>
            </span>
            <div class="topbar-dropdown-title">
                <h4 class="mb-0">Menú</h4>
            </div>
            <ng-scrollbar class="message-center notifications admin-menu-list">
                <a class="message-item topbar-menu-item text-decoration-none" *ngFor="let item of menuAdmin"
                    [routerLink]="[item.path]">
                    <span class="topbar-menu-icon {{ item.btn }}">
                        <i class="{{ item.icon }}"></i>
                    </span>
                    <span class="mail-contnet d-inline-block ps-3 align-middle">
                        <h5 class="message-title">{{ item.name }}</h5>
                    </span>
                </a>
            </ng-scrollbar>
        </div>
    </li>
</ul>

<ul class="navbar-nav topbar-actions topbar-user-nav ms-auto">
    <li class="nav-item topbar-user" ngbDropdown placement="bottom-end">
        <span class="topbar-role-badge">Administrador</span>

        <a ngbDropdownToggle class="nav-link topbar-avatar-toggle waves-effect waves-dark pro-pic"
            href="javascript:void(0)" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <img src="assets/images/users/user4.jpg" alt="user" class="rounded-circle" width="34" height="34" />
        </a>

        <div class="dropdown-menu-end user-dd dropdown-menu-animate-up app-user-dropdown" ngbDropdownMenu>
            <span class="with-arrow">
                <span class="bg-primary"></span>
            </span>
            <div class="app-user-summary">
                <img src="assets/images/users/user4.jpg" alt="user" class="img-circle" width="54" height="54" />
                <div class="min-w-0" *ngIf="user">
                    <h4 class="mb-0">{{ user.family_name }} {{ user.given_name }}</h4>
                    <p class="mb-0">{{ user.email }}</p>
                </div>
            </div>

            <button type="button" class="dropdown-item app-dropdown-action" (click)="logout()">
                <i class="fa fa-power-off me-2"></i>Logout
            </button>
        </div>
    </li>
</ul>
